import gql from "graphql-tag";
const getGenoplotsamples = gql(` 
query getGenoplotsamples($group: String!, $sample: String!) {
  getGenoplotsamples(group: $group, sample: $sample) {
	group
	sample
	customgroup
	alias
	outlier
	age
	SSE
	coords
	coords2
	entityType
	description
	geo
	download
	ethnicity
	origin
	created
	owner
	vendor
	bucket
	storage
	object
	simulated
	public
	scaled
	v2
	type
	variability
  } 
}   
`)
export default getGenoplotsamples
